import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import URLSearchParams from 'url-search-params'

import { approveEmployee } from '../../api/api'

import Loading from '../../Components/loading/Loading'
import { Routes } from '../../routing/routes'
import { ApiResponse } from '../../types/plann3r'

const CompanyApprove: FC = () => {
  const history = useHistory()

  const companyId = new URLSearchParams(window.location.search).get(
    'companyId',
  )
  const employeeId = new URLSearchParams(window.location.search).get(
    'employeeId',
  )
  const key = new URLSearchParams(window.location.search).get('key')

  if (companyId && employeeId && key) {
    approveEmployee(companyId, employeeId, key).then((response: ApiResponse) => {
      if (response.success) {
        history.push(Routes.PAGES_MANAGEMENT)
      } else {
        alert('Something went wrong, please try again.')
      }
      return null
    // eslint-disable-next-line no-console
    }).catch((e) => console.log(e))
  } else {
    history.push(Routes.HOME)
  }

  return (
    <div className="has-text-centered">
      <Loading />
    </div>
  )
}

export default CompanyApprove
